import { ArrowBackIosNew } from "@mui/icons-material";
import { Box, Button } from "@mui/material";

interface CustomPaginationProps {
  totalPages?: number;
  currentPage?: number; // zero-based index
  onPageChange?: (page: number) => void;
  count?: number;
  pageSize?: number;
}

const CustomPagination = ({
  totalPages = 1,
  currentPage = 0,
  onPageChange = () => { },
  count = 0,
  pageSize = 10,
}: CustomPaginationProps) => {
  const computedTotalPages = count > 0 ? Math.ceil(count / pageSize) : totalPages;
  const startItem = count === 0 ? 0 : currentPage * pageSize + 1;
  const endItem = Math.min((currentPage + 1) * pageSize, count);

  const getPageNumbers = () => {
    const maxVisible = 4;
    const start = Math.max(0, currentPage - Math.floor(maxVisible / 2));
    const end = Math.min(computedTotalPages, start + maxVisible);

    return Array.from({ length: end - start }, (_, i) => start + i);
  };



  return (
    <div className="pagination">
      <p>
        Showing <strong> {startItem}-{endItem}</strong> from <strong> {count} </strong>data
      </p>
      <Box display="flex" alignItems="center">
        <Button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 0}
          className="page-btn"
        >
          <ArrowBackIosNew />
        </Button>

        <div className="count_page" style={{ display: "flex", gap: "8px" }}>
          {getPageNumbers().map((pageIndex) => (
            <Button
              key={pageIndex}
              variant={currentPage === pageIndex ? "contained" : "outlined"}
              onClick={() => onPageChange(pageIndex)}
              className={`page-btn ${currentPage === pageIndex ? "active" : ""
                }`}
            >
              {pageIndex + 1}
            </Button>
          ))}
        </div>

        <Button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === computedTotalPages - 1 || computedTotalPages === 0}
          className="page-btn"
        >
          <ArrowBackIosNew />
        </Button>
      </Box>
    </div>
  );
};

export default CustomPagination;
